import { render, staticRenderFns } from "./BidRejectedBidWanted.vue?vue&type=template&id=54c511c7&"
import script from "./BidRejectedBidWanted.vue?vue&type=script&lang=js&"
export * from "./BidRejectedBidWanted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports